import axios from "axios";

// Canonical production host. The edge already 308s www → apex; this guard covers any
// stale client that still lands on www so the SPA, its API calls and auth cookies share one origin.
export const CANONICAL_HOST = "accommodationsuppliers.com";
if (typeof window !== "undefined" && window.location.hostname === `www.${CANONICAL_HOST}`) {
  window.location.replace(`${window.location.protocol}//${CANONICAL_HOST}${window.location.pathname}${window.location.search}${window.location.hash}`);
}

// Same-origin API base — using a relative URL means the API is called on the
// same hostname the browser is on (accommodationsuppliers.com/api in prod,
// preview host/api in dev). This eliminates cross-origin cookie problems that
// browsers block regardless of SameSite / CORS. If the browser needs an absolute
// URL (rare — SSR, tests), REACT_APP_BACKEND_URL is still honoured.
// NOTE: REACT_APP_BACKEND_URL for production must be https://accommodationsuppliers.com (apex, no www).
const ENV_BACKEND_URL = (process.env.REACT_APP_BACKEND_URL || "").trim();
const BACKEND_URL = ENV_BACKEND_URL && typeof window !== "undefined" &&
  new URL(ENV_BACKEND_URL, window.location.origin).origin === window.location.origin
    ? ENV_BACKEND_URL   // same-origin absolute — keep it
    : "";                // cross-origin or missing → drop to relative /api
export const API = `${BACKEND_URL}/api`;
export const ASSET_BASE = BACKEND_URL;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export const absUrl = (path) => {
  if (!path) return "";
  if (path.startsWith("http")) return path;
  return `${BACKEND_URL}${path}`;
};
